module.exports = __webpack_public_path__ + "img/storj.c952db66.svg";